





























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ChooseDevice from "./singlechoice.vue";
import Moment from "moment-timezone";
import echarts from "echarts";

class PageMeterRequest extends PageRequest {
    keyword: string = "";
    startTime: string;
    endTime: string;
    deviceId: any[] = [];
    page: number;
    pageSize: number;
    sortBy: string;
    descending: boolean;
    filterFileds: any;
    dataType: number = 1;
}

@Component({
    components: { ChooseDevice },
})
export default class EletricalParameters extends AbpBase {
    //filters
    pagerequest: PageMeterRequest = new PageMeterRequest();
    chooseModal: boolean = false; //选择窗体是否显示
    //choosemeters: Array<any> = []; //已经选择表计
    splitnum: number = 0.1;
    height: number = 230;
    loadingdata: boolean = false;
    paramscolumns: any[] = [];//已选择电参数
    usebar: any; //图表
    /**电参数 */
    paramstype: number = 1;
    //显示选择表计框
    showchoosedevice() {
        this.chooseModal = true;
    }
    //获取子组件回传值
    getdevicelist(data: any) {
        this.pagerequest.deviceId = [];
        data.forEach((ele) => {
            this.pagerequest.deviceId.push(ele.id);
            this.pagerequest.keyword = ele.meterNo + '>>' + ele.roomNo;
        });
        this.getpage(this.paramstype);
    }
    cleardata() {
        this.pagerequest.deviceId = [];
    }
    //改变排序
    changeSort(key) {
        if (key.order === "desc" || key.order === "normal") {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = true;
        } else {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = false;
        }
        this.getpage(this.paramstype);
    }
    get list() {
        //console.log(this.$store.state.monitor.list)
        return this.$store.state.monitor.list;
    }
    get loading() {
        return this.$store.state.monitor.loading;
    }
    isActiveChange(val: number) {
        this.$store.commit("monitor/setCurrentPage", 1);
        this.getpage(this.paramstype);
    }
    pageChange(page: number) {
        this.$store.commit("monitor/setCurrentPage", page);
        this.getpage(this.paramstype);
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("monitor/setPageSize", pagesize);
        this.getpage(this.paramstype);
    }
    async getpage(params: number) {
        this.pagerequest.pageSize = this.pageSize;
        this.pagerequest.page = this.currentPage;
        this.pagerequest.dataType = this.paramstype;
        if (this.pagerequest.deviceId.length == 0 || this.pagerequest.deviceId.length > 1) {
            this.$Modal.warning({
                title: this.L("Tips"),
                content: this.L("ChooseMeters"),
            });
            return;
        }
        await this.$store.dispatch({ type: "monitor/getESRecordList", data: this.pagerequest, });
        this.getparams(params);
    }
    get pageSize() {
        return this.$store.state.monitor.pageSize;
    }
    get totalCount() {
        return this.$store.state.monitor.totalCount;
    }
    get currentPage() {
        return this.$store.state.monitor.currentPage;
    }
    //列信息
    columns = [
        {
            type: "index",
            width: 70,
            align: "left",
            fixed: "left",
            key: "index",
            title: this.L("IndexNo"),
            sortId: 0,
        },
        {
            sortable: true,
            title: this.L("Meter"),
            key: "meterNo",
            resizable: true,
            width: 130,
            fixed: "left",
            sortId: 2,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.meterNo,
                        },
                    },
                    params.row.meterNo
                );
            },
        },
        {
            title: this.L("LastReadTime"),
            key: "readTime",
            sortable: true,
            sortType: "desc",
            width: 150,
            //fixed: "right",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.readTime == null
                        ? ""
                        : Moment(params.row.readTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("Va"),
            key: "va",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.va == null
                        ? ""
                        : parseFloat(params.row.va).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vb"),
            key: "vb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vb == null
                        ? ""
                        : parseFloat(params.row.vb).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vc"),
            key: "vc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vc == null
                        ? ""
                        : parseFloat(params.row.vc).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vab"),
            key: "vab",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vab == null
                        ? ""
                        : parseFloat(params.row.vab).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vbc"),
            key: "vbc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vbc == null
                        ? ""
                        : parseFloat(params.row.vbc).toFixed(1)
                );
            },
        },
        {
            title: this.L("Vca"),
            key: "vca",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vca == null
                        ? ""
                        : parseFloat(params.row.vca).toFixed(1)
                );
            },
        },
        {
            title: this.L("Ia"),
            key: "ia",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ia == null
                        ? ""
                        : parseFloat(params.row.ia).toFixed(3)
                );
            },
        },
        {
            title: this.L("Ib"),
            key: "ib",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ib == null
                        ? ""
                        : parseFloat(params.row.ib).toFixed(3)
                );
            },
        },
        {
            title: this.L("Ic"),
            key: "ic",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ic == null
                        ? ""
                        : parseFloat(params.row.ic).toFixed(3)
                );
            },
        },
        {
            title: this.L("FA"),
            key: "fa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.fa == null
                        ? ""
                        : parseFloat(params.row.fa).toFixed(2)
                );
            },
        },
        {
            title: this.L("FB"),
            key: "fb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.fb == null
                        ? ""
                        : parseFloat(params.row.fb).toFixed(2)
                );
            },
        },
        {
            title: this.L("FC"),
            key: "fc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.fc == null
                        ? ""
                        : parseFloat(params.row.fc).toFixed(2)
                );
            },
        },
        {
            title: this.L("Pt"),
            key: "pt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pt == null
                        ? ""
                        : parseFloat(params.row.pt).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pa"),
            key: "pa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pa == null
                        ? ""
                        : parseFloat(params.row.pa).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pb"),
            key: "pb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pb == null
                        ? ""
                        : parseFloat(params.row.pb).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pc"),
            key: "pc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pc == null
                        ? ""
                        : parseFloat(params.row.pc).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qt"),
            key: "qt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qt == null
                        ? ""
                        : parseFloat(params.row.qt).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qa"),
            key: "qa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qa == null
                        ? ""
                        : parseFloat(params.row.qa).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qb"),
            key: "qb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qb == null
                        ? ""
                        : parseFloat(params.row.qb).toFixed(4)
                );
            },
        },
        {
            title: this.L("Qc"),
            key: "qc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.qc == null
                        ? ""
                        : parseFloat(params.row.qc).toFixed(4)
                );
            },
        },
        {
            title: this.L("St"),
            key: "st",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.st == null
                        ? ""
                        : parseFloat(params.row.st).toFixed(4)
                );
            },
        },
        {
            title: this.L("Sa"),
            key: "sa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sa == null
                        ? ""
                        : parseFloat(params.row.sa).toFixed(4)
                );
            },
        },
        {
            title: this.L("Sb"),
            key: "sb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sb == null
                        ? ""
                        : parseFloat(params.row.sb).toFixed(4)
                );
            },
        },
        {
            title: this.L("Sc"),
            key: "sc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.sc == null
                        ? ""
                        : parseFloat(params.row.sc).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFt"),
            key: "pft",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pft == null
                        ? ""
                        : parseFloat(params.row.pft).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFa"),
            key: "pfa",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pfa == null
                        ? ""
                        : parseFloat(params.row.pfa).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFb"),
            key: "pfb",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pfb == null
                        ? ""
                        : parseFloat(params.row.pfb).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFc"),
            key: "pfc",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pfc == null
                        ? ""
                        : parseFloat(params.row.pfc).toFixed(4)
                );
            },
        },
        {
            title: this.L("MaxImum"),
            key: "maxImum",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.maxImum == null
                        ? ""
                        : parseFloat(params.row.maxImum).toFixed(2)
                );
            },
        },
        {
            title: this.L("MaxImumTime"),
            key: "maxImumTime",
            align: "center",
            width: 130,
        },
        {
            title: this.L("ReadNum"),
            key: "ept",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ept == null
                        ? ""
                        : parseFloat(params.row.ept).toFixed(4)
                );
            },
        },
        {
            title: this.L("Tip"),
            key: "eptj",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptj == null
                        ? ""
                        : parseFloat(params.row.eptj).toFixed(4)
                );
            },
        },
        {
            title: this.L("Peak"),
            key: "eptf",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptf == null
                        ? ""
                        : parseFloat(params.row.eptf).toFixed(4)
                );
            },
        },
        {
            title: this.L("Flat"),
            key: "eptp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptp == null
                        ? ""
                        : parseFloat(params.row.eptp).toFixed(4)
                );
            },
        },
        {
            title: this.L("Valley"),
            key: "eptg",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eptg == null
                        ? ""
                        : parseFloat(params.row.eptg).toFixed(4)
                );
            },
        },
        {
            title: this.L("P"),
            key: "p",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.p == null
                        ? ""
                        : parseFloat(params.row.p).toFixed(4)
                );
            },
        },
        {
            title: this.L("Eqt"),
            key: "eqt",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.eqt == null
                        ? ""
                        : parseFloat(params.row.eqt).toFixed(4)
                );
            },
        },
        {
            title: this.L("Pep"),
            key: "pep",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pep == null
                        ? ""
                        : parseFloat(params.row.pep).toFixed(4)
                );
            },
        },
        {
            title: this.L("Mep"),
            key: "mep",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mep == null
                        ? ""
                        : parseFloat(params.row.mep).toFixed(4)
                );
            },
        },
        {
            title: this.L("Meq"),
            key: "meq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.meq == null
                        ? ""
                        : parseFloat(params.row.meq).toFixed(4)
                );
            },
        },
        {
            title: this.L("VLNavg"),
            key: "vLNavg",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vLNavg == null
                        ? ""
                        : parseFloat(params.row.vLNavg).toFixed(1)
                );
            },
        },
        {
            title: this.L("VLLage"),
            key: "vLLage",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vLLage == null
                        ? ""
                        : parseFloat(params.row.vLLage).toFixed(1)
                );
            },
        },
        {
            title: this.L("IAvg"),
            key: "iAvg",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.iAvg == null
                        ? ""
                        : parseFloat(params.row.iAvg).toFixed(3)
                );
            },
        },
        {
            title: this.L("IM"),
            key: "iM",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.iM == null
                        ? ""
                        : parseFloat(params.row.iM).toFixed(3)
                );
            },
        },
        {
            title: this.L("PTipEp"),
            key: "pTipEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pTipEp == null
                        ? ""
                        : parseFloat(params.row.pTipEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PPeakEp"),
            key: "pPeakEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pPeakEp == null
                        ? ""
                        : parseFloat(params.row.pPeakEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFlatEp"),
            key: "pFlatEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFlatEp == null
                        ? ""
                        : parseFloat(params.row.pFlatEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PValleyEp"),
            key: "pValleyEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pValleyEp == null
                        ? ""
                        : parseFloat(params.row.pValleyEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MTipEp"),
            key: "mTipEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mTipEp == null
                        ? ""
                        : parseFloat(params.row.mTipEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MPeakEp"),
            key: "mPeakEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mPeakEp == null
                        ? ""
                        : parseFloat(params.row.mPeakEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MFlatEp"),
            key: "mFlatEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mFlatEp == null
                        ? ""
                        : parseFloat(params.row.mFlatEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("MValleyEp"),
            key: "mValleyEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mValleyEp == null
                        ? ""
                        : parseFloat(params.row.mValleyEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("PTipEq"),
            key: "pTipEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pTipEq == null
                        ? ""
                        : parseFloat(params.row.pTipEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("PPeakEq"),
            key: "pPeakEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pPeakEq == null
                        ? ""
                        : parseFloat(params.row.pPeakEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("PFlatEq"),
            key: "pFlatEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pFlatEq == null
                        ? ""
                        : parseFloat(params.row.pFlatEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("PValleyEq"),
            key: "pValleyEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pValleyEq == null
                        ? ""
                        : parseFloat(params.row.pValleyEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MTipEq"),
            key: "mTipEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mTipEq == null
                        ? ""
                        : parseFloat(params.row.mTipEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MPeakEq"),
            key: "mPeakEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mPeakEq == null
                        ? ""
                        : parseFloat(params.row.mPeakEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MFlatEq"),
            key: "mFlatEq",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mFlatEq == null
                        ? ""
                        : parseFloat(params.row.mFlatEq).toFixed(4)
                );
            },
        },
        {
            title: this.L("MValleyEq"),
            key: "mValleyEp",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.mValleyEp == null
                        ? ""
                        : parseFloat(params.row.mValleyEp).toFixed(4)
                );
            },
        },
        {
            title: this.L("IaHarmonic"),
            key: "iaHr",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.iaHr == null
                        ? ""
                        : parseFloat(params.row.iaHr).toFixed(4)
                );
            },
        },
        {
            title: this.L("IbHarmonic"),
            key: "ibHr",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.ibHr == null
                        ? ""
                        : parseFloat(params.row.ibHr).toFixed(4)
                );
            },
        },
        {
            title: this.L("IcHarmonic"),
            key: "icHr",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.icHr == null
                        ? ""
                        : parseFloat(params.row.icHr).toFixed(4)
                );
            },
        },
        {
            title: this.L("VaHarmonic"),
            key: "vaHr",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vaHr == null
                        ? ""
                        : parseFloat(params.row.vaHr).toFixed(4)
                );
            },
        },
        {
            title: this.L("VcHarmonic"),
            key: "vbHr",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vbHr == null
                        ? ""
                        : parseFloat(params.row.vbHr).toFixed(4)
                );
            },
        },
        {
            title: this.L("VbHarmonic"),
            key: "vcHr",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.vcHr == null
                        ? ""
                        : parseFloat(params.row.vcHr).toFixed(4)
                );
            },
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            width: 130,
            resizable: true,
            sortId: 19,
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title:
                                    info.length > 0 ? info[0].displayName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].displayName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Areas"),
            key: "areaId",
            sortable: true,
            width: 130,
            resizable: true,
            sortId: 20,
            render: (h: any, params: any) => {
                let id = params.row.areaId;
                let ite = JSON.parse(localStorage.getItem("areas"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].fullName : this.L("Unknown")
                    ),
                ]);
            },
        }
    ];
    //过滤电参数
    getparams(params: number) {
        this.usebar.resize();
        this.usebar.clear();
        this.paramscolumns = [];
        let legend = [];
        let xAxis = [];
        let series = [];
        switch (params) {
            case 1://电流
                this.paramstype = 1;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "ia" || ele.key == "ib" || ele.key == "ic"
                })
                legend = ['A相电流', 'B相电流', 'C相电流'];
                let iadata = [];
                let ibdata = [];
                let icdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    iadata.push(ele.ia == null ? 0 : ele.ia);
                    ibdata.push(ele.ib == null ? 0 : ele.ib);
                    icdata.push(ele.ic == null ? 0 : ele.ic);
                });
                series.push({ data: iadata, name: 'A相电流', type: 'line' });
                series.push({ data: ibdata, name: 'B相电流', type: 'line' });
                series.push({ data: icdata, name: 'C相电流', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 2://电压 
                this.paramstype = 2;
                legend = ['A相电压', 'B相电压', 'C相电压'];
                let vadata = [];
                let vbdata = [];
                let vcdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    vadata.push(ele.va == null ? 0 : ele.va);
                    vbdata.push(ele.vb == null ? 0 : ele.vb);
                    vcdata.push(ele.vc == null ? 0 : ele.vc);
                });
                series.push({ data: vadata, name: 'A相电压', type: 'line' });
                series.push({ data: vbdata, name: 'B相电压', type: 'line' });
                series.push({ data: vcdata, name: 'C相电压', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "va" || ele.key == "vb" || ele.key == "vc" || ele.key == "vab" || ele.key == "vbc" || ele.key == "vca"
                })
                break;
            case 3://用电量
                this.paramstype = 3;
                legend = ['总用量', '尖用量', '峰用量', '平用量', '谷用量'];
                let eptdata = [];
                let eptjdata = [];
                let eptfdata = [];
                let eptpdata = [];
                let eptgdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    eptdata.push(ele.ept == null ? 0 : ele.ept);
                    eptjdata.push(ele.eptj == null ? 0 : ele.eptj);
                    eptfdata.push(ele.eptf == null ? 0 : ele.eptf);
                    eptpdata.push(ele.eptp == null ? 0 : ele.eptp);
                    eptgdata.push(ele.eptg == null ? 0 : ele.eptg);
                });
                series.push({ data: eptdata, name: '总用量', type: 'line' });
                series.push({ data: eptjdata, name: '尖用量', type: 'line' });
                series.push({ data: eptfdata, name: '峰用量', type: 'line' });
                series.push({ data: eptpdata, name: '平用量', type: 'line' });
                series.push({ data: eptgdata, name: '谷用量', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "ept" || ele.key == "eptj" || ele.key == "eptf" || ele.key == "eptp" || ele.key == "eptg"
                })
                break;
            case 4://功率
                this.paramstype = 4;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "pt" || ele.key == "pa" || ele.key == "pb" || ele.key == "pc"
                })
                legend = ['总有功功率', 'A相有功功率', 'B相有功功率', 'C相有功功率'];
                let ptdata = [];
                let padata = [];
                let pbdata = [];
                let pcdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    ptdata.push(ele.pt == null ? 0 : ele.pt);
                    padata.push(ele.pa == null ? 0 : ele.pa);
                    pbdata.push(ele.pb == null ? 0 : ele.pb);
                    pcdata.push(ele.pc == null ? 0 : ele.pc);
                });
                series.push({ data: ptdata, name: '总有功功率', type: 'line' });
                series.push({ data: padata, name: 'A相有功功率', type: 'line' });
                series.push({ data: pbdata, name: 'B相有功功率', type: 'line' });
                series.push({ data: pcdata, name: 'C相有功功率', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 5://谐波
                this.paramstype = 5;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "iaHr" || ele.key == "ibHr" || ele.key == "icHr" || ele.key == "vaHr" || ele.key == "vbHr" || ele.key == "vcHr"
                })
                legend = ['A相电流谐波', 'B相电流谐波', 'C相电流谐波', 'A相电压谐波', 'B相电压谐波', 'C相电压谐波'];
                let iahrdata = [];
                let ibhrdata = [];
                let ichrdata = [];
                let vahrdata = [];
                let vbhrdata = [];
                let vchrdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    iahrdata.push(ele.iaHr == null ? 0 : ele.iaHr);
                    ibhrdata.push(ele.ibHr == null ? 0 : ele.ibHr);
                    ichrdata.push(ele.icHr == null ? 0 : ele.icHr);
                    vahrdata.push(ele.vaHr == null ? 0 : ele.vaHr);
                    vbhrdata.push(ele.vbHr == null ? 0 : ele.vbHr);
                    vchrdata.push(ele.vcHr == null ? 0 : ele.vcHr);
                });
                series.push({ data: iahrdata, name: 'A相电流谐波', type: 'line' });
                series.push({ data: ibhrdata, name: 'B相电流谐波', type: 'line' });
                series.push({ data: ichrdata, name: 'C相电流谐波', type: 'line' });
                series.push({ data: vahrdata, name: 'A相电压谐波', type: 'line' });
                series.push({ data: vbhrdata, name: 'B相电压谐波', type: 'line' });
                series.push({ data: vchrdata, name: 'C相电压谐波', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 6://功率因数
                this.paramstype = 6;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "pft" || ele.key == "pfa" || ele.key == "pfb" || ele.key == "pfc"
                })
                legend = ['总功率因数', 'A相功率因数', 'B相功率因数', 'C相功率因数'];
                let pftdata = [];
                let pfadata = [];
                let pfbdata = [];
                let pfcdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    pftdata.push(ele.pft == null ? 0 : ele.pft);
                    pfadata.push(ele.pfa == null ? 0 : ele.pfa);
                    pfbdata.push(ele.pfb == null ? 0 : ele.pfb);
                    pfcdata.push(ele.pfc == null ? 0 : ele.pfc);
                });
                series.push({ data: pftdata, name: '总功率因数', type: 'line' });
                series.push({ data: pfadata, name: 'A相功率因数', type: 'line' });
                series.push({ data: pfbdata, name: 'B相功率因数', type: 'line' });
                series.push({ data: pfcdata, name: 'C相功率因数', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 7://视在功率
                this.paramstype = 7;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "st" || ele.key == "sa" || ele.key == "sb" || ele.key == "sc"
                })
                legend = ['总视在功率', 'A相视在功率', 'B相视在功率', 'C相视在功率'];
                let stdata = [];
                let sadata = [];
                let sbdata = [];
                let scdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    stdata.push(ele.st == null ? 0 : ele.st);
                    sadata.push(ele.sa == null ? 0 : ele.sa);
                    sbdata.push(ele.sb == null ? 0 : ele.sb);
                    scdata.push(ele.sc == null ? 0 : ele.sc);
                });
                series.push({ data: stdata, name: '总视在功率', type: 'line' });
                series.push({ data: sadata, name: 'A相视在功率', type: 'line' });
                series.push({ data: sbdata, name: 'B相视在功率', type: 'line' });
                series.push({ data: scdata, name: 'C相视在功率', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 8://无功功率
                this.paramstype = 8;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "qt" || ele.key == "qa" || ele.key == "qb" || ele.key == "qc"
                })
                legend = ['总无功功率', 'A相无功功率', 'B相无功功率', 'C相无功功率'];
                let qtdata = [];
                let qadata = [];
                let qbdata = [];
                let qcdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    qtdata.push(ele.qt == null ? 0 : ele.qt);
                    qadata.push(ele.qa == null ? 0 : ele.qa);
                    qbdata.push(ele.qb == null ? 0 : ele.qb);
                    qcdata.push(ele.qc == null ? 0 : ele.qc);
                });
                series.push({ data: qtdata, name: '总无功功率', type: 'line' });
                series.push({ data: qadata, name: 'A相无功功率', type: 'line' });
                series.push({ data: qbdata, name: 'B相无功功率', type: 'line' });
                series.push({ data: qcdata, name: 'C相无功功率', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 9://频率
                this.paramstype = 9;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" || ele.key == "meterNo" || ele.key == "readTime" || ele.key == "organizationId" || ele.key == "areaId" || ele.key == "fa" || ele.key == "fb" || ele.key == "fc"
                })
                legend = ['A相频率', 'B相频率', 'C相频率'];
                let fadata = [];
                let fbdata = [];
                let fcdata = [];
                this.$store.state.monitor.list.forEach((ele) => {
                    xAxis.push(Moment(ele.readTime).format("HH:mm"));
                    fadata.push(ele.fa == null ? 0 : ele.fa);
                    fbdata.push(ele.fb == null ? 0 : ele.fb);
                    fcdata.push(ele.fc == null ? 0 : ele.fc);
                });
                series.push({ data: fadata, name: 'A相频率', type: 'line' });
                series.push({ data: fbdata, name: 'B相频率', type: 'line' });
                series.push({ data: fcdata, name: 'C相频率', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            default:
                this.paramscolumns = this.columns;
                break;
        }
    }
    changdate(val) {
        this.pagerequest.startTime = val;
        this.getpage(this.paramstype)
    }
    async created() {
        this.pagerequest.startTime = Moment().format("YYYY-MM-DD ");
        this.pagerequest.sortBy = "readTime";
        this.pagerequest.descending = false;
        this.$store.commit("monitor/setPageSize", 50);
        this.getparams(this.paramstype);//默认电流参数
    }

    data() {
        return {
            pageSizeOpts: [50, 100, 300, 600, 1000],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
            //柱形图参数
            baroption(legend, xAxis, series) {
                return {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "line", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    legend: {
                        data: legend,
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: xAxis,
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                        },
                    ],
                    series: series,
                };
            },
        };
    }
    mounted() {
        if (window.innerHeight > 800) {
            this.height = window.innerHeight - 500;
            (document.getElementById("echarts") as HTMLDivElement).style.height = "300px";
        } else {
            this.height = window.innerHeight - 560;
            (document.getElementById("echarts") as HTMLDivElement).style.height =
                "200px";
        }
        this.usebar = echarts.init(
            document.getElementById("echarts") as HTMLDivElement
        );
        //自动缩放
        window.addEventListener("resize", () => {
            this.usebar.resize();
        });
        this.getparams(this.paramstype);
    }
}
